const methods = ({ request }) => ({
  // Looks up cheat sheets for a year/week
  getByWeek: async (year, week, formulaId, rookiesOnly) =>
    request(`CheatSheets/Standard/${year}/${week}/${formulaId}/${rookiesOnly}`),
  getByWeekDynasty: async (year) =>
    request(`CheatSheets/Dynasty/${year}`),
  getByWeekAuction10: async (year) =>
    request(`CheatSheets/Auction/10/${year}`),
  getByWeekAuction12: async (year) =>
    request(`CheatSheets/Auction/12/${year}`),
  getByWeekTop200: async (year) =>
    request(`CheatSheets/Top200/${year}`),
  getByWeekTop200PPR: async (year) =>
    request(`CheatSheets/Top200PPR/${year}`),
  getByWeekTop200QB: async (year) =>
    request(`CheatSheets/Top200QB/${year}`),
});

export default methods;



// WEBPACK FOOTER //
// ./src/lib/api/cheatSheets.js